import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "d-flex flex-row align-items-center w-100 font-weight-bold mb-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" }, null, -1)
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "d-flex flex-row align-items-center w-100 separator-bottom font-weight-bold p-4" }
const _hoisted_6 = {
  key: "messages.attachments",
  class: "table-column-name d-flex flex-row align-items-center"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  style: {"width":"180px"},
  class: "flex-shrink-0 d-none d-lg-flex"
}
const _hoisted_9 = { class: "m-0" }
const _hoisted_10 = {
  style: {"width":"180px"},
  class: "flex-shrink-0 d-none d-lg-block"
}
const _hoisted_11 = { class: "m-0" }
const _hoisted_12 = {
  key: 0,
  style: {"width":"180px"},
  class: "flex-shrink-0 d-none d-lg-block"
}
const _hoisted_13 = { class: "m-0" }
const _hoisted_14 = {
  class: "flex-grow-1",
  style: {"width":"240px"}
}
const _hoisted_15 = {
  key: 0,
  class: "m-0"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-paperclip" }, null, -1)
const _hoisted_20 = { class: "w-100 d-flex flex-row justify-content-between align-items-center" }
const _hoisted_21 = { class: "flex-grow-1" }
const _hoisted_22 = { class: "mb-1 text-dark" }
const _hoisted_23 = { class: "badge badge-light" }
const _hoisted_24 = { class: "mb-1 text-dark" }
const _hoisted_25 = { class: "badge badge-light" }
const _hoisted_26 = { class: "mb-1 text-dark" }
const _hoisted_27 = { class: "badge badge-light" }
const _hoisted_28 = {
  key: 0,
  class: "mb-1 text-dark"
}
const _hoisted_29 = { class: "badge badge-light" }
const _hoisted_30 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" }, null, -1)
const _hoisted_32 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_translate = _resolveComponent("translate")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TipTapTextArea = _resolveComponent("TipTapTextArea")!
  const _component_RoomDetails = _resolveComponent("RoomDetails")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_InfiniteList = _resolveComponent("InfiniteList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AnimatedInput, {
        modelValue: _ctx.searchTerm,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
        modelModifiers: { lazy: true, trim: true },
        type: "text",
        label: _ctx.i18n.$gettext('Nachricht Suchen'),
        style: {"max-width":"400px"}
      }, null, 8, ["modelValue", "label"]),
      _createVNode(_component_Button, {
        class: "flex-shrink-0 ml-auto",
        onClick: _ctx.openCreateMessageDialog
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode("  "),
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Nachricht verfassen")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Dialog, {
        header: _ctx.i18n.$gettext('Nachricht verfassen'),
        visible: _ctx.showCreateMessageDialog,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showCreateMessageDialog) = $event)),
        onHide: _ctx.resetCreateMessageDialog,
        modal: ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Abbrechen'),
            icon: "pi pi-times",
            class: "p-button-text",
            onClick: _ctx.resetCreateMessageDialog
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Senden'),
            icon: "pi pi-envelope",
            autofocus: "",
            disabled: !_ctx.messageSubject || (!_ctx.messageText && !_ctx.messageRoomId),
            onClick: _ctx.createMessage
          }, null, 8, ["label", "disabled", "onClick"])
        ]),
        default: _withCtx(() => [
          (_ctx.rpcClient.isInternalUser && !(_ctx.isReply && _ctx.recipientOrganizationId))
            ? (_openBlock(), _createBlock(_component_Multiselect, {
                key: 0,
                modelValue: _ctx.selectedRecipients,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedRecipients) = $event)),
                  _ctx.processRecipientsSelection
                ],
                options: [{ id: 0, name: _ctx.i18n.$gettext('Alle Teilnehmer') },...(_ctx.organizations?.data || [])],
                loading: _ctx.organizations?.call?.loading,
                filter: "",
                showClear: "",
                optionLabel: "name",
                optionValue: "id",
                label: _ctx.recipientsLabelText,
                disabled: _ctx.isReply,
                class: "w-100 mb-4"
              }, null, 8, ["modelValue", "options", "loading", "label", "disabled", "onUpdate:modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.messageSubject,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.messageSubject) = $event)),
            modelModifiers: { lazy: true, trim: true },
            class: "mb-4",
            type: "text",
            label: _ctx.i18n.$gettext('Betreff')
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_TipTapTextArea, {
            ref: "editor",
            modelValue: _ctx.messageText,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.messageText) = $event)),
            modelModifiers: { lazy: true, trim: true },
            type: "text",
            class: "mb-4",
            placeholder: _ctx.i18n.$gettext('Nachricht'),
            required: ""
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_RoomDetails, {
            onRoomCreated: _cache[4] || (_cache[4] = id => { this.messageRoomId = id })
          })
        ]),
        _: 1
      }, 8, ["header", "visible", "onHide"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          key: "messages.date",
          class: "table-column-name d-flex flex-row align-items-center flex-shrink-0 d-none d-lg-block",
          style: {"width":"180px"},
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setSort('created')))
        }, [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Datum")
            ]),
            _: 1
          }),
          _createElementVNode("span", {
            style: {"width":"15px"},
            class: _normalizeClass((_ctx.sortBy.length && _ctx.sortBy[0].endsWith('asc') ? 'cil-arrow-top' : 'cil-arrow-bottom') + (_ctx.sortBy.length && _ctx.sortBy[0].startsWith('created') ? '' : ' opacity-0'))
          }, null, 2)
        ]),
        _createElementVNode("div", {
          key: "messages.sender",
          class: "table-column-name d-flex flex-row align-items-center flex-shrink-0 d-none d-lg-block",
          style: {"width":"180px"},
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setSort('senderOrganizationId')))
        }, [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Absender")
            ]),
            _: 1
          }),
          _createElementVNode("span", {
            style: {"width":"15px"},
            class: _normalizeClass((_ctx.sortBy.length && _ctx.sortBy[0].endsWith('asc') ? 'cil-arrow-top' : 'cil-arrow-bottom') + (_ctx.sortBy.length && _ctx.sortBy[0].startsWith('senderOrganizationId') ? '' : ' opacity-0'))
          }, null, 2)
        ]),
        (_ctx.rpcClient.isInternalUser)
          ? (_openBlock(), _createElementBlock("div", {
              key: "messages.recipients",
              class: "table-column-name d-flex flex-row align-items-center flex-shrink-0 d-none d-lg-block",
              style: {"width":"180px"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setSort('recipientNames')))
            }, [
              _createVNode(_component_translate, { style: {"word-break":"break-word"} }, {
                default: _withCtx(() => [
                  _createTextVNode("Empfänger")
                ]),
                _: 1
              }),
              _createElementVNode("span", {
                style: {"width":"15px"},
                class: _normalizeClass((_ctx.sortBy.length && _ctx.sortBy[0].endsWith('asc') ? 'cil-arrow-top' : 'cil-arrow-bottom') + (_ctx.sortBy.length && _ctx.sortBy[0].startsWith('recipientNames') ? '' : ' opacity-0'))
              }, null, 2)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          key: "messages.subject",
          class: "table-column-name d-flex flex-row align-items-center flex-grow-1",
          style: {"width":"240px"},
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setSort('messageSubject')))
        }, [
          _createVNode(_component_translate, { style: {"word-break":"break-word"} }, {
            default: _withCtx(() => [
              _createTextVNode("Betreff")
            ]),
            _: 1
          }),
          _createElementVNode("span", {
            style: {"width":"15px"},
            class: _normalizeClass((_ctx.sortBy.length && _ctx.sortBy[0].endsWith('asc') ? 'cil-arrow-top' : 'cil-arrow-bottom') + (_ctx.sortBy.length && _ctx.sortBy[0].startsWith('messageSubject') ? '' : ' opacity-0'))
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_translate, { style: {"word-break":"break-word"} }, {
            default: _withCtx(() => [
              _createTextVNode("Anhänge")
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_InfiniteList, {
        "get-all-items": _ctx.sort((_ctx.messages.data || []).filter(p => _ctx.matchesSearchTerm(p))),
        "id-property": 'id',
        "auto-scroll-at-start": ""
      }, {
        element: _withCtx((props) => [
          _createElementVNode("div", {
            class: "d-flex flex-row align-items-center w-100 list-row px-4 clickable",
            onClick: _withModifiers(($event: any) => (_ctx.openMessage(props.item)), ["stop","prevent"])
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.dateTimeString(props.item.created)), 1),
              (!props.item.read)
                ? (_openBlock(), _createBlock(_component_Tag, {
                    key: 0,
                    class: "ml-2",
                    value: _ctx.i18n.$gettext('neu')
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(props.item.senderName || (!props.item.senderOrganizationId ? _ctx.i18n.$gettext('Vergabestelle') : '')), 1)
            ]),
            (_ctx.rpcClient.isInternalUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString((props.item.recipientNames || []).join(', ')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              (props.item.messageSubject)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(props.item.messageSubject), 1))
                : (props.item.messageText)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      innerHTML: _ctx.safeRender(props.item.messageText)
                    }, null, 8, _hoisted_16))
                  : _createCommentVNode("", true)
            ]),
            (props.item.roomId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("p", _hoisted_18, [
                    _createTextVNode(_toDisplayString(props.item.attachmentCount) + " ", 1),
                    _hoisted_19
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_7)
        ]),
        _: 1
      }, 8, ["get-all-items"]),
      _createVNode(_component_Dialog, {
        header: ' ',
        visible: _ctx.showMessage,
        "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showMessage) = $event)),
        onHide: _ctx.closeMessage,
        modal: ""
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Betreff")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.message.messageSubject), 1)
              ]),
              _createElementVNode("p", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Datum")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.dateTimeString(_ctx.message.created)), 1)
              ]),
              _createElementVNode("p", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Absender")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString((_ctx.message.senderName || (!_ctx.message.senderOrganizationId ? _ctx.i18n.$gettext('Vergabestelle') : '')) + ' (' + _ctx.message.userName + ')'), 1)
              ]),
              (_ctx.message.recipientNames?.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, [
                      _createVNode(_component_translate, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Empfänger")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(":")
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.message.recipientNames.join(', ')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            ((_ctx.rpcClient.isInternalUser && _ctx.message.senderOrganizationId) || (!_ctx.rpcClient.isInternalUser && !_ctx.message.senderOrganizationId))
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(_component_Button, {
                    class: "flex-shrink-0 ml-auto mr-3",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.reply(_ctx.message)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31,
                      _createTextVNode("  "),
                      _createVNode(_component_translate, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Antworten")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        footer: _withCtx(() => []),
        default: _withCtx(() => [
          (_ctx.message && _ctx.message.messageText)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "mx-1 my-4",
                innerHTML: _ctx.safeRender(_ctx.message.messageText)
              }, null, 8, _hoisted_32))
            : _createCommentVNode("", true),
          (_ctx.message.roomId)
            ? (_openBlock(), _createBlock(_component_RoomDetails, {
                key: 1,
                "room-id": _ctx.message.roomId,
                header: _ctx.i18n.$gettext('Anhänge'),
                disabled: ""
              }, null, 8, ["room-id", "header"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible", "onHide"])
    ])
  ]))
}